import React from 'react'
import AdminProfileComponent from '../Components/AdminProfileComponent'

function AdminProfilePage() {
  return (
    <div>
      <AdminProfileComponent />
    </div>
  )
}

export default AdminProfilePage